export enum CommonModalActionTypes {
  CLOSE = 'close',
}
